// src/components/data/securityUsersStore.js

export const securityUsersDemo = [
  {
    id: 1,
    username: "webmaster",
    nombreCompleto: "Webmaster Demo",
    email: "webmaster@metalone.mx",
    rol: "Administrador",
    area: "Capacitación",
    estado: "Activo",
    ultimaConexion: "10/01/2025 09:12",
  },
  {
    id: 2,
    username: "jlopez",
    nombreCompleto: "Juan López",
    email: "juan.lopez@metalone.mx",
    rol: "Supervisor",
    area: "Operaciones",
    estado: "Activo",
    ultimaConexion: "09/30/2025 18:40",
  },
  {
    id: 3,
    username: "mgarcia",
    nombreCompleto: "María García",
    email: "maria.garcia@metalone.mx",
    rol: "Instructor",
    area: "Capacitación",
    estado: "Activo",
    ultimaConexion: "09/29/2025 11:05",
  },
  {
    id: 4,
    username: "rcastillo",
    nombreCompleto: "Roberto Castillo",
    email: "roberto.castillo@metalone.mx",
    rol: "Auditor",
    area: "Riesgos",
    estado: "Activo",
    ultimaConexion: "09/28/2025 16:20",
  },
  {
    id: 5,
    username: "asanchez",
    nombreCompleto: "Ana Sánchez",
    email: "ana.sanchez@metalone.mx",
    rol: "Usuario",
    area: "Comercial",
    estado: "Activo",
    ultimaConexion: "09/27/2025 08:55",
  },
  {
    id: 6,
    username: "cjimenez",
    nombreCompleto: "Carlos Jiménez",
    email: "carlos.jimenez@metalone.mx",
    rol: "Usuario",
    area: "Operaciones",
    estado: "Inactivo",
    ultimaConexion: "09/10/2025 14:10",
  },
  {
    id: 7,
    username: "lrodriguez",
    nombreCompleto: "Laura Rodríguez",
    email: "laura.rodriguez@metalone.mx",
    rol: "Supervisor",
    area: "Cumplimiento",
    estado: "Activo",
    ultimaConexion: "09/26/2025 12:33",
  },
  {
    id: 8,
    username: "fmartinez",
    nombreCompleto: "Fernando Martínez",
    email: "fernando.martinez@metalone.mx",
    rol: "Usuario",
    area: "Back Office",
    estado: "Activo",
    ultimaConexion: "09/25/2025 09:47",
  },
  {
    id: 9,
    username: "cortega",
    nombreCompleto: "Claudia Ortega",
    email: "claudia.ortega@metalone.mx",
    rol: "Instructor",
    area: "Capacitación",
    estado: "Activo",
    ultimaConexion: "09/24/2025 17:02",
  },
  {
    id: 10,
    username: "hcastaneda",
    nombreCompleto: "Héctor Castañeda",
    email: "hector.castaneda@metalone.mx",
    rol: "Usuario",
    area: "Finanzas",
    estado: "Inactivo",
    ultimaConexion: "09/05/2025 10:15",
  },
];

export function getSecurityUsers() {
  return securityUsersDemo;
}
